import { useChannelTalk } from '@repo/channel-talk';
import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import UnexpectedError from '@/components/tax-refund/common/view/ErrorView/UnexpectedError';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

const CorporationHometaxEtcErrorPage = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();
  const { openChannelTalk } = useChannelTalk();

  const handleClickExit = () => {
    sendClickEvent('corps-lookup_error-etc_close');
    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  const handleAsk = () => {
    sendClickEvent('corps-lookup_error-etc_cx');
    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="corps-lookup_error-etc" />
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <UnexpectedError onPrimaryButtonClick={handleAsk} />
      </Layout>
    </AuthGuard>
  );
};

export default CorporationHometaxEtcErrorPage;
